import * as React from 'react'
import * as AppStore from './../../state/app-store'
import { Modal } from '@mantine/core'
import { useRouter } from 'next/router'

import * as Types from '../../declarations'
import * as Selectors from './../../state/selectors'
import * as Actions from './../../state/actions'
import TextFeedback from './TextFeedback'
import ImageUpload from './ImageUpload'
import AccountNudge from '../AccountNudge'

const SuggestEditModal = ({
	version,
	resourceId,
}: // resourceType,
{
	version: Types.VERSION
	resourceId: number
	// resourceType: Types.App.DataTypes.ResourceType
}) => {
	const router = useRouter()
	const { asPath } = router
	const isAdminRoute = asPath.startsWith('/admin')

	const currentFeedbackEditSection = AppStore.useAppSelector(
		Selectors.currentFeedbackEditSection,
	)
	const isOpen = !!currentFeedbackEditSection
	const isPictureUploadOrTextFeedback =
		currentFeedbackEditSection === Types.App.DataTypes.FeedbackSection.PICTURES

	const dispatch = AppStore.useAppDispatch()

	const close = () => dispatch(Actions.closeSuggestFeedbackModal())

	const authedUser = AppStore.useAppSelector(Selectors.authedUser)

	const isAuthedUser = !!authedUser

	if (isAdminRoute) {
		return <></>
	}

	const title = (() => {
		switch (currentFeedbackEditSection) {
			case Types.App.DataTypes.FeedbackSection.PICTURES:
				return 'Add a picture'
			case Types.App.DataTypes.FeedbackSection.SUGGEST_ROUTE:
				return 'Suggest a route to add'
			default:
				return 'Suggest edit'
		}
	})()

	return (
		<>
			<Modal opened={isOpen} onClose={close} title={title} size="md">
				{!isAuthedUser && (
					<AccountNudge variant="modal" version={version} closeModal={close} />
				)}

				{isAuthedUser && (
					<>
						{isPictureUploadOrTextFeedback && (
							<ImageUpload
								version={Types.App.DataTypes.TripVersion.LIVE}
								resourceId={resourceId}
								// default to trip
								resourceType={Types.App.DataTypes.ResourceType.UNIQUE_TRIP}
							/>
						)}
						{!isPictureUploadOrTextFeedback && (
							// todo: pass down feedback section and send to api
							<TextFeedback version={version} />
						)}
					</>
				)}
			</Modal>
		</>
	)
}

export default SuggestEditModal
